import { createRoot } from 'react-dom/client';

// Use shared root.css for consistent styles with main app
import '@components/root.css';

import App from './App';
import { setupClient } from './setup.client';

// Webview-specific overrides (if any)
import './index.css';

// Initialize client-side services
setupClient();

// Mobile webview optimizations
if (typeof window !== 'undefined') {
  // Disable zoom on iOS webviews
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover',
    );
  }

  // Prevent scrolling bounce on iOS
  document.body.style.overscrollBehavior = 'none';

  // Log webview info for debugging
  console.log('🔍 Webview Environment:', {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    cookieEnabled: navigator.cookieEnabled,
    timestamp: new Date().toISOString(),
  });
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
} else {
  console.error('Failed to find root element for webview app');
}
